<template>
  <router-view />
</template>

<script>
export default {
  name: 'InformationEventsRouterContainer'
};
</script>